<template>
  <div class="hightScore">
    <h1>王炸资料</h1>
    <div class="scoreCard" v-for="(ele, index) in collectList" :key="index">
      <img class="cardImg" :src="'https://cdn.scoreupup.com' + ele.img" />
      <div class="scoreCardRight">
        <h2>{{ ele.title }}</h2>
        <div>
          <a>{{ ele.time }}</a>
          <a>{{ ele.author }}</a>
          <a><img src="@/assets/lookWihte.png" /></a>
          <a>{{ ele.view_count }}</a>
        </div>
        <span v-html="ele.content"></span>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/aboutGMAT.js";
export default {
  data() {
    return {
      collectList: [],
      page: 1,
      limit: 10,
      total: null,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      let params = {
        page: this.page,
        limit: this.limit,
      };
      let query = this.$qs.stringify(params);
      api
        .mostDatas(query)
        .then((res) => {
          this.collectList = res.data.data;
          console.log(res);
          // console.log(JSON.stringify(res));
        })
        .catch((err) => {
          this.$message.error("获取数据失败");
        });
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/mostData.css";
</style>



// WEBPACK FOOTER //
// src/view/opporTunity/mostData.vue